module.exports = __webpack_public_path__ + "img/auto_test_banner.8d9ca264.png";